#import "../../../shared/graphql/fragments/sales-document-fragment.graphql"

query GetQuoteById($id: ID!) {
    quote(id: $id) {
        ...SalesDocumentFragment
    }
}
